import SmtpService from '../services/smtp.service';
// Check if we have the sweet alert toast functions or need to use direct SweetAlert
let errorToast, successToast;
try {
  const toastModule = require('../services/sweetalert');
  if (toastModule.errorToast && toastModule.successToast) {
    ({ errorToast, successToast } = toastModule);
  } else {
    // Fallback to using the default sweetalert service
    const sweetAlertService = require('../services/sweetalert').default;
    errorToast = (message) => {
      if (window.$swal) {
        window.$swal(sweetAlertService.error({ response: { data: { message } } }));
      }
    };
    successToast = (message) => {
      if (window.$swal) {
        window.$swal(sweetAlertService.success(message));
      }
    };
  }
} catch (e) {
  console.error('Could not load sweetalert toast functions:', e);
  // Create dummy functions to prevent errors
  errorToast = (message) => console.error('Error Toast:', message);
  successToast = (message) => console.log('Success Toast:', message);
}

export const app = {
  namespaced: true,
  state: {
    mail_domain: '',
    mails: [],
    rulesets: {},
    templates: [],
    current_mail: {},
    current_rulesets: {},
    current_ruleset: {},
    current_template: {},
    session_id: '',
    smtp_config: {
      mail_provider: 'ses', // 'ses' oder 'smtp'
      smtp_config: {
        host: '',
        port: 587,
        secure: false,
        username: '',
        password: '',
        require_tls: true,
        sender_name: '',
        sender_email: ''
      }
    },
    smtp_test_status: null, // null, 'testing', 'success', 'error'
    smtp_test_message: ''
  },
  getters: {
    smtpConfig: state => state.smtp_config,
    smtpTestStatus: state => state.smtp_test_status,
    smtpTestMessage: state => state.smtp_test_message
  },
  mutations: {
    updateSendAddress(state, send_address) {
      state.current_mail.send_address = send_address
    },
    updateSendName(state, send_name) {
      state.current_mail.send_name = send_name
    },
    setSmtpConfig(state, config) {
      state.smtp_config = config
    },
    updateSmtpConfig(state, { key, value }) {
      if (key === 'smtp_config') {
        // Bei verschachtelter Struktur muss ein tiefes Merge erfolgen
        state.smtp_config.smtp_config = { ...state.smtp_config.smtp_config, ...value }
      } else {
        state.smtp_config[key] = value
      }
    },
    setSmtpTestStatus(state, { status, message }) {
      state.smtp_test_status = status
      state.smtp_test_message = message || ''
    }
  },
  actions: {
    // SMTP Konfiguration laden
    fetchSmtpConfig({ commit }) {
      return SmtpService.getSmtpConfig()
        .then(response => {
          commit('setSmtpConfig', response)
          return response
        })
        .catch(error => {
          console.error('Fehler beim Laden der SMTP-Konfiguration:', error)
          errorToast('Fehler beim Laden der SMTP-Konfiguration')
          throw error
        })
    },
    
    // SMTP Konfiguration speichern
    saveSmtpConfig({ commit, state }, options = {}) {
      commit('setSmtpTestStatus', { status: null, message: '' })
      
      console.log('Sende SMTP-Konfiguration an Backend:', state.smtp_config)
      
      return SmtpService.updateSmtpConfig(state.smtp_config)
        .then(response => {
          commit('setSmtpConfig', response)
          
          // Only show toast if customHandling is not true
          if (!options.customHandling) {
            successToast('SMTP-Konfiguration erfolgreich gespeichert')
          }
          
          return response
        })
        .catch(error => {
          console.error('Fehler beim Speichern der SMTP-Konfiguration:', error)
          
          // Only show toast if customHandling is not true
          if (!options.customHandling) {
            errorToast('Fehler beim Speichern der SMTP-Konfiguration')
          }
          
          throw error
        })
    },
    
    // SMTP Verbindung testen
    testSmtpConnection({ commit, state }) {
      commit('setSmtpTestStatus', { status: 'testing', message: 'Verbindung wird getestet...' })
      
      console.log('Teste SMTP-Verbindung mit:', state.smtp_config)
      
      return SmtpService.testSmtpConnection(state.smtp_config)
        .then(response => {
          commit('setSmtpTestStatus', { 
            status: 'success', 
            message: response.message || 'Verbindung erfolgreich hergestellt'
          })
          return response
        })
        .catch(error => {
          console.error('Fehler beim Testen der SMTP-Verbindung:', error)
          let errorMessage = 'Verbindung fehlgeschlagen'
          
          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message
          } else if (typeof error === 'object' && error.message) {
            errorMessage = error.message
          }
          
          commit('setSmtpTestStatus', { 
            status: 'error', 
            message: errorMessage
          })
          
          throw error
        })
    }
  }
};
